import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { Icon } from 'antd';
import { connect } from 'react-redux';
import styles from './IntroduccioSelectorImatgeFenofase.module.css';
import {
  MIDA_MAX_FOTO_FENOFASE_BYTES,
  MISSATGE_USUARI_NO_ACTIU,
} from '../../constantsFormularis';
import {
  extensionsPermesesEnString,
  fitxerTipusNoPermes,
} from '../../utils/gestioImatges';
import { errorConsultaServidor } from '../../actions';
import {
  crearNotificacioFotoSuperaMidaPermesa,
  crearNotificacioFotoTipusNoPermes,
} from '../../utils/notificacio';
import { getUsuari } from '../../reducers';
import { fetchObtenirDadesUsuariPerIdObservador } from '../../actions/consultesServidor';
import configuracio from '../../configuracioEntorns';

const unitatImatge = 'MB';

const converteixBytesAMB = (midaEnBytes) => {
  return (midaEnBytes / 1000 / 1000).toFixed(2);
};

const fitxerSuperaMidaMaximaPermesa = (midaFitxerEnMB, midaMaximaFotosEnMB) => {
  return midaFitxerEnMB > midaMaximaFotosEnMB;
};

class IntroduccioSelectorImatgeFenofase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usuariNoActiu: false,
    };
    this.modificarImatgeSeleccionada = this.modificarImatgeSeleccionada.bind(
      this
    );
    this.seleccionarImatge = this.seleccionarImatge.bind(this);
  }

  modificarImatgeSeleccionada(fitxer) {
    const midaMaximaFotosEnMB = converteixBytesAMB(
      MIDA_MAX_FOTO_FENOFASE_BYTES
    );
    const midaFitxerEnMB = converteixBytesAMB(fitxer.size);
    const tipusFitxer = fitxer.type;

    if (fitxerTipusNoPermes(tipusFitxer)) {
      crearNotificacioFotoTipusNoPermes();
      return;
    }

    if (fitxerSuperaMidaMaximaPermesa(midaFitxerEnMB, midaMaximaFotosEnMB)) {
      crearNotificacioFotoSuperaMidaPermesa(
        midaFitxerEnMB,
        unitatImatge,
        midaMaximaFotosEnMB
      );
      return;
    }

    const obtenirUrlImatgeSeleccionada = (fitxer) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const { crearFoto, fenofase } = this.props;
        crearFoto({
          idFenofase: fenofase.idFenofase,
          idIndividu: fenofase.fenofaseIdIndividu,
          url: event.target.result,
          fitxer: fitxer,
        });
      };
      reader.readAsDataURL(fitxer);
    };

    obtenirUrlImatgeSeleccionada(fitxer);
  }

  gestioError = (error, tipusError) => {
    if (tipusError === MISSATGE_USUARI_NO_ACTIU) {
      this.setState({ usuariNoActiu: true });
    }
    this.props.errorConsultaServidor(error, tipusError);
  };

  seleccionarImatge() {
    fetchObtenirDadesUsuariPerIdObservador(this.props.usuari.idObservador).then(
      (dadesUsuari) => {
        if (dadesUsuari.actiu) {
          // si l'input té emmagatzemada una imatge, cal netejar-lo
          if (this.inputHTML5.value) {
            this.inputHTML5.value = '';
          }

          //es força un clic a l'element input d'HTML5
          this.inputHTML5.click();
        } else {
          this.gestioError('Avís Error', MISSATGE_USUARI_NO_ACTIU);
        }
      },
      (error) => {
        this.gestioError(error, 'Error canviant imatge fenofase.');
      }
    );
  }

  render() {
    const { usuariNoActiu } = this.state;

    if (usuariNoActiu) {
      const urlBase = configuracio.ruta;
      return <Redirect to={`${urlBase}/login`} />;
    }

    // input de tipus "file" d'HTML5, resta ocult però s'usa la funcionalitat de seleccionar arxiu
    const inputHTML5 = (
      <form method="POST" encType="multipart/form-data">
        <input
          ref={(ref) => (this.inputHTML5 = ref)}
          type="file"
          accept={extensionsPermesesEnString}
          onChange={(event) =>
            this.modificarImatgeSeleccionada(event.target.files[0])
          }
        />
      </form>
    );

    // zona que cal clicar quan es vol seleccionar una imatge
    const selectorImatge = (
      <div
        role="button"
        tabIndex="0"
        className={
          styles.fenofaseIntroduccioSelectorImatgeContenidorImatgeAfegir
        }
        onClick={this.seleccionarImatge}
      >
        <Icon type="camera" style={{ fontSize: 20 }} />
      </div>
    );

    return (
      <div className={styles.fenofaseIntroduccioSelectorImatge}>
        {inputHTML5}
        {selectorImatge}
      </div>
    );
  }
}

IntroduccioSelectorImatgeFenofase.propTypes = {
  urlImatgeOriginal: PropTypes.string,
  crearFoto: PropTypes.func,
  fenofase: PropTypes.object,
  usuari: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    usuari: getUsuari(state),
  };
};

const mapDispatchToProps = { errorConsultaServidor };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IntroduccioSelectorImatgeFenofase);
